"use strict";

import angular from "angular";

import template from "./analysis-plus-selection.component.html";
import "./themes/analysis-plus-selection.component.scss";

import _ from "lodash";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

import { Budget } from "../../../entity/Budget/Budget";
import { Projection } from "../../../entity/Projection/Projection";
import { Available } from "../../../gateway/Available/Available";
import { DashboardAvailable } from "../../../gateway/DashboardAvailable/DashboardAvailable";
import { Scenario } from "../../../gateway/Scenario/Scenario";
import { Serie } from "../../../gateway/Serie/Serie";
import { Visualization } from "../../../gateway/Visualization/Visualization";
import { CompanyDataAvailable } from "../../../presentation/services/CompanyDataAvailable/CompanyDataAvailable";
import { DashboardsViewService } from "../../../presentation/services/DashboardsView/DashboardsViewService";
import { Events } from "../../../presentation/services/Events/Events";
import { GoalsDataService } from "../../../presentation/services/GoalsDataService";
import { PublicCompany } from "../../../presentation/services/PublicCompany/PublicCompany";
import { SeriesService } from "../../../presentation/services/Series/SeriesService";
import alertChangesGoalsDialogTemplate from "../../../views/accounting/company/showtime/dialogs/alert-changes-goals/alert-changes-goals-dialog.html";

class AnalysisPlusSelectionComponent {
    activateTourAnalysisPlus = false;
    ScenarioDomain = new Scenario();
    Available = new Available();
    Visualization = new Visualization();
    SerieDomain = new Serie();
    SeriesService = new SeriesService(this.SerieDomain);
    GoalsDataService = new GoalsDataService();
    CompanyDataAvailable = new CompanyDataAvailable();
    DashboardAvailable = new DashboardAvailable();
    DashboardsViewService = new DashboardsViewService({
        AvailableHttpGateway: this.Available,
        CompanyDataAvailableHttpGateway: this.CompanyDataAvailable,
        DashboardAvailableHttpGateway: this.DashboardAvailable
    });
    Events = new Events();
    projections = [];
    budgets = [];
    projectionModel = "";
    budgetModel = "";
    projectionStatusModel = false;
    budgetStatusModel = false;
    hasChanges = false;
    hasChangeGoals = false;
    goalsStatusModel = false;
    availableLinear = [];
    goalsRules = [];
    loadingGoals = true;
    loading = false;

    constructor(
        $scope,
        LoaderService,
        DSNDialogService,
        AccountingFactory,
        $state
    ) {
        this.$scope = $scope;
        this.LoaderService = LoaderService;
        this.DSNDialogService = DSNDialogService;
        this.AccountingFactory = AccountingFactory;
        this.$state = $state;
    }

    $onInit() {
        this.hasPermissionCompanyModel = PublicCompany.hasPermissionModelToModify(
            this.companyData._id,
            new UserDataAdapter().user()
        );
        this.setProjections();
        this.setBudgets();
        this.setProjectionModel();
        this.setBudgetModel();
        this.setAvailableLinear();
        this._setGoalsModel();
        this.hasChangeGoals = false;

        if (
            this.showtime &&
            this.current.goals &&
            this.visualization?.goals?.length
        ) {
            this.setGoalsRules();
        } else {
            this.loadingGoals = false;
        }
    }

    $onChanges(changes) {
        if (
            typeof changes.triggerSaveGoals?.currentValue === "boolean" &&
            typeof changes.triggerSaveGoals?.previousValue != "object"
        ) {
            this.onApply();
        }
    }

    sourceAvailable({ source, dashboardId }) {
        return this.DashboardsViewService.getValidateSource({
            source,
            dashboardId,
            companyId: this.companyData._id,
            currentSource: this.current.source
        });
    }

    async setGoalsRules() {
        this.loadingGoals = true;
        const _source = this.sourceAvailable({
            source: this.current.source,
            dashboardId: this.current.dashboardId
        });
        await this.SerieDomain.populateAccountsPlans({
            companyIds: [this.companyData._id],
            source: _source,
            origin: "goals"
        });
        const goalsIds = this.SeriesService.getGoalsIds({
            visualization: this.visualization
        });
        const series = this.SeriesService.getByByIds(goalsIds);
        const goalsRules = await this.GoalsDataService.getList({
            series,
            visualization: this.visualization
        });
        this.goalsRules = goalsRules;
        this.loadingGoals = false;
        this.$scope.$applyAsync();
    }

    _setGoalsModel() {
        // O grupo nao tem Objetivos: a regra e definida por indicador da empresa. Sem zerar aqui,
        // um `goals` herdado da tela anterior seguiria ligado sem switch para desligar.
        this.goalsStatusModel = this.companyData.isGroup
            ? false
            : this.current.goals;
    }

    setProjections() {
        const scenarios = this.ScenarioDomain.getByCompanyIdAndSource(
            this.companyData._id,
            this.current.dashboard.sources[0],
            "projection"
        );
        this.projections = [];
        for (const projection of scenarios) {
            const projectionEntity = new Projection(projection);
            if (projection._id === "ORIGINAL")
                projectionEntity.setNameAndId({
                    _id: "PROGRESSAO_LINEAR",
                    name: "Projeção Linear"
                });
            this.projections.push(projectionEntity);
        }
        this.projectionModel = angular.copy(this.current.projection);
        if (this.current.projection) this.projectionStatusModel = true;
    }

    setProjectionModel() {
        this.projectionModel = angular.copy(this.current.projection);
        if (this.current.projection) this.projectionStatusModel = true;
    }

    setBudgets() {
        const scenarios = this.ScenarioDomain.getByCompanyIdAndSource(
            this.companyData._id,
            this.current.dashboard.sources[0],
            "budget",
            { removeOriginal: true }
        );
        this.budgets = [];
        for (const projection of scenarios) {
            const budgetEntity = new Budget(projection);
            this.budgets.push(budgetEntity);
        }
    }

    getTooltipBudget() {
        if (!this.budgets.length)
            return `<style>
            .dsn-tooltip-wrapper {
             right: 146px !important;
            }
            </style>
            <div style='width: 360px'>Para ativar, é necessário criar um Orçamento ( <i class='fas fa-coins'></i> )<div>`;
        return "";
    }

    setBudgetModel() {
        this.budgetModel = angular.copy(this.current.budget);
        if (this.current.budget) this.budgetStatusModel = true;
    }

    setAvailableLinear() {
        const available = this.Available.get({
            companyId: this.companyData._id,
            scenarioId: "ORIGINAL",
            source: this.current.dashboard.sources[0],
            options: { projection: "PROGRESSAO_LINEAR", separatted: true }
        });
        this.availableLinear = _.get(available, "availableDates", []);
    }

    sendEvents({ projection, budget, goals }) {
        if (projection) this.Events.send("projecao.aplicar.analiseplus");
        if (budget) this.Events.send("orcamento.aplicar.analiseplus");
        if (goals) this.Events.send("objetivos.aplicar.analiseplus");
    }

    async onApply() {
        const hasChangeGoals = angular.copy(this.hasChangeGoals);
        this.hasChangeGoals = false;
        this.loading = true;
        this.LoaderService.setProgress(true);
        const params = {
            projection: {
                status: this.projectionStatusModel,
                _id: this.projectionModel
            },
            budget: {
                status: this.budgetStatusModel,
                _id: this.budgetModel
            },
            goals: this.goalsStatusModel
        };
        this.sendEvents({
            projection: params.projection.status,
            budget: params.budget.status,
            goals: params.goals
        });
        if (hasChangeGoals) await this.saveGoals();
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.onApplyAnalysisPlus({ params });
    }

    onClear() {
        const params = {};
        if (this.activateTourAnalysisPlus) return;
        this.projectionModel = "";
        this.projectionStatusModel = false;
        this.budgetModel = "";
        this.budgetStatusModel = false;
        this.hasChangeGoals = false;
        this.onClearAnalysisPlus({ params });
    }

    onCancel() {
        if (this.hasChangeGoals) return this.openGoalsChangesDialog();
        if (this.sidenavInstance) this.sidenavInstance.close();
        this.onCloseSidenav();
    }

    onChangeSwitchProjection() {
        this.budgetModel = "";
        this.budgetStatusModel = false;
        if (!this.hasChanges && this.availableLinear.length >= 2) {
            this.projectionModel = "PROGRESSAO_LINEAR";
        }
        this.hasChanges = true;
    }

    onChangeSwitchBudget() {
        this.projectionModel = "";
        this.projectionStatusModel = false;
        this.hasChanges = true;
    }

    onChangeSwitchGoals() {
        if (
            this.goalsStatusModel &&
            !this.goalsRules?.length &&
            this.showtime &&
            this.visualization?.goals?.length
        )
            this.setGoalsRules();
        this.hasChanges = true;
    }

    onChangeModel() {
        this.hasChanges = true;
    }

    isDisabledTour() {
        if (this.activateTourAnalysisPlus) return true;
    }
    isDisabled() {
        if (!this.hasChanges) return true;
        if (this.projectionStatusModel && !this.projectionModel) return true;
        if (this.budgetStatusModel && !this.budgetModel) return true;
        return false;
    }

    onEditGoal(index) {
        this.hasChanges = true;
        this.hasChangeGoals = true;
        const input = document.querySelector(`.goal-input-${index} input`);
        input.focus();
        input.select();
    }

    onChangeGoal() {
        this.hasChanges = true;
        this.hasChangeGoals = true;
    }

    async saveGoals() {
        await this.GoalsDataService.save({
            goalsRules: this.goalsRules,
            date: this.current.period.date,
            source: this.current.source,
            company: this.companyData
        });
    }

    openGoalsChangesDialog() {
        this.DSNDialogService.custom({
            controller: "AlertChangesGoalsDialog",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                title: "Tem certeza que deseja sair sem salvar?",
                width: "517px",
                templateHtml: alertChangesGoalsDialogTemplate
            },
            after: {
                hide: (response) => {
                    const actions = {
                        close: () => {
                            this.hasChangeGoals = false;
                            setTimeout(() => {
                                this.onCloseSidenav();
                            }, 500);
                        },
                        save: () => {
                            this.onApply();
                        }
                    };
                    if (actions[response]) actions[response]();
                }
            }
        });
    }

    onNewProjection() {
        const source = this.current.dashboard?.sources?.[0];
        const states = {
            accounting: {
                state: "nucont.accounting.company.projection.accounting",
                source: "accounting"
            },
            fin: {
                state: "nucont.accounting.company.projection.fin",
                source: "fin"
            },
            tax: {
                state: "nucont.accounting.company.projection.tax",
                source: "tax"
            },
            simplesNacional: {
                state: "nucont.accounting.company.projection.tax",
                source: "tax",
                accountPlanType: "simplesNacional"
            },
            personnel: {
                state: "nucont.accounting.company.projection.personnel",
                source: "personnel"
            },
            eSocial: {
                state: "nucont.accounting.company.projection.personnel",
                source: "personnel",
                accountPlanType: "eSocial"
            }
        };
        return this.$state.go(states[source].state, {
            source: states[source].source,
            accountPlanType: states[source].accountPlanType
        });
    }

    onNewBudget() {
        const source = this.current.dashboard?.sources?.[0];
        console.log(source);
        const states = {
            accounting: {
                state: "nucont.accounting.company.budget.accounting",
                source: "accounting"
            },
            fin: {
                state: "nucont.accounting.company.budget.fin",
                source: "fin"
            },
            tax: {
                state: "nucont.accounting.company.budget.tax",
                source: "tax"
            },
            simplesNacional: {
                state: "nucont.accounting.company.budget.tax",
                source: "tax",
                accountPlanType: "simplesNacional"
            },
            personnel: {
                state: "nucont.accounting.company.budget.personnel",
                source: "personnel"
            },
            eSocial: {
                state: "nucont.accounting.company.budget.personnel",
                source: "personnel",
                accountPlanType: "eSocial"
            }
        };
        return this.$state.go(states[source].state, {
            source: states[source].source,
            accountPlanType: states[source].accountPlanType
        });
    }
}

export { AnalysisPlusSelectionComponent };

AnalysisPlusSelectionComponent.$inject = [
    "$scope",
    "LoaderService",
    "DSNDialogService",
    "AccountingFactory",
    "$state"
];

const name = "analysisPlusSelectionComponent";
const def = {
    bindings: {
        companyData: "<",
        current: "<",
        onApplyAnalysisPlus: "&",
        onClearAnalysisPlus: "&",
        sidenavInstance: "<",
        projectionModel: "<",
        projectionStatusModel: "<",
        budgetStatusModel: "<",
        projectionStatusModel: "<",
        budgetModel: "<",
        onCloseSidenav: "&",
        showtime: "<",
        accountingEntity: "<",
        visualization: "<",
        hasChangeGoals: "=",
        triggerSaveGoals: "<",
        goalsStatusModel: "<",
        activateTourAnalysisPlus: "="
    },
    controller: AnalysisPlusSelectionComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
